import { createAction } from "@reduxjs/toolkit";

export const resetSearchResults = createAction(
  "lda-frontend/reset/searchResults",
);

export const resetPatientData = createAction("lda-frontend/reset/patientData");
